module.exports = __webpack_public_path__ + "media/icons/tick-turquoise-fc302c99.svg";